import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router';
import { useT } from '../lib/i18n.tsx';
import { carryOver } from '../lib/url-state.ts';
import { Button } from './ui/button.tsx';

/**
 * Returns to the previous page of this tab, or to `fallback` (with the period and filters kept)
 * when the page was opened directly from a link or bookmark.
 */
export function BackButton({ fallback }: { fallback: string }) {
  const t = useT();
  const navigate = useNavigate();
  const { search } = useLocation();
  const goBack = (): void => {
    // React Router stores the position in the tab's history; 0 means this is the first page.
    const index = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (index > 0) void navigate(-1);
    else void navigate({ pathname: fallback, search: carryOver(new URLSearchParams(search)) });
  };
  return (
    <Button variant="ghost" size="sm" className="-ml-2" onClick={goBack}>
      <ArrowLeft aria-hidden="true" className="size-4" />
      {t.nav.back}
    </Button>
  );
}
